export const IDENTIFICATION_DATA_OPTIONS = [
    {value:"BVN", name: "BVN"},
    {value:"BVN_NG", name: "BVN_NG"},
    {value:"NIN_NG", name: "NIN_NG"},
    {value:"SSN_US", name: "SSN_US"},
    {value:"NATIONAL_ID", name: "NATIONAL_ID"},
    {value:"VOTERS_CARD", name: "VOTERS_CARD"},
    {value:"DRIVERS_LICENSE", name: "DRIVERS_LICENSE"},
    {value:"INTERNATIONAL_PASSPORT", name: "INTERNATIONAL_PASSPORT"},
]